import axios from "axios";
import AuthenticatedClient from "@/carto-node/lib/clients/authenticated"
import { setWithExpiry } from "@/store/utils/localStorageUtil"
import getCARTOData from "@/store/utils/getCARTOData"
import Cookies from 'js-cookie';
import { getWithExpiry } from "../../utils/localStorageUtil";

const MAPSCLOUD_AUTH_SERVER = process.env.VUE_APP_MAPSCLOUD_AUTH_SERVER
const CARTODB_AUTH_SERVER = process.env.VUE_APP_CARTODB_AUTH_SERVER
const CARTODB_SERVER = process.env.VUE_APP_CARTODB_SERVER

let checkCartoUserCreationIntervalId

function get_cookie_domain() {
  const location = window.location.href
  const domain = location.split('/')[2].split('.').slice(-2).join('.')
  return "." + domain
}

export async function loginByUsername(context, loginForm) {
  const loginUrl = "/v1.0/user/auto_reg_login"

  const request = {
    method: 'post',
    baseURL: MAPSCLOUD_AUTH_SERVER,
    url: loginUrl,
    data: loginForm,
  }
  try {
    const resp = await axios(request)
    const { data: { status, msg, data } } = resp
    if (status > 0) {
      context.commit("setLoginError", msg)
    }
    else {
      context.commit("setLoginError", null)
      context.commit("setMapscloudUser", data)
      const { access_token } = data
      document.cookie = `mapscloud_auth=${access_token}; domain=${get_cookie_domain()}`
      context.dispatch("loginCartodb", access_token)
    }
  }
  catch (err) {
    context.commit("setLoginError", "login mapscloud error")
  }
}
export async function getUserJWT(context) {
  const jwtUrl = "/v1.0/user/jwt"

  const request = {
    method: 'POST',
    baseURL: MAPSCLOUD_AUTH_SERVER,
    url: jwtUrl,
  }
  try {
    const resp = await axios(request)
    const { data: { status, data: jwt } } = resp
    if (status > 0) {
      context.commit("setLoginError", "get mapscloud user jwt error")
    }
    else {
      context.commit("setLoginError", null)
      // context.commit("setMapscloudUser", data)
      document.cookie = `mapscloud_auth=${jwt}; domain=${get_cookie_domain()}`
      context.dispatch("loginCartodb", jwt)
    }
  }
  catch (err) {
    context.commit("setLoginError", "login mapscloud error")
  }
}
export async function loginByMobile(context, loginForm) {
  console.log("loginByMobile")
  const loginUrl = "/v1.0/user/mobile/login"

  const request = {
    method: 'post',
    baseURL: MAPSCLOUD_AUTH_SERVER,
    url: loginUrl,
    data: loginForm
  }
  const resp = await axios(request)
  const { data: { status, message, data, jwt } } = resp
  if (status > 0) {
    context.commit("setLoginError", message)
  }
  else {
    context.commit("setLoginError", null)
    context.commit("setMapscloudUser", data)
    document.cookie = `mapscloud_auth=${jwt}; domain=${get_cookie_domain()}`
    context.dispatch("loginCartodb", jwt)
  }
}

//社会化登录:wechat/qq/weibo
//callback会传入session,通过将session写入cookie，实现登录
//FIXME: 必须是同域
export async function loginBySocial(context, session) {
  console.log("loginBySocial")
  //TODO: 调用GET /v1.0/user/me
  context.dispatch("getUserJWT", session)
}

export async function loginCartodb(context) {
  const loginUrl = "/autologin_api"
  const request = {
    method: 'get',
    baseURL: CARTODB_AUTH_SERVER,
    url: loginUrl,
  }
  try {
    const resp = await axios(request)
    let { data: { current_user: user } } = resp

    if (user) {
      context.commit("setLoginError", null)
      context.dispatch("getCartdbConfig", user)
    }
    else {
      context.commit("setLoginError", "cartodb login error")
    }
  }
  catch (err) {
    context.commit("setLoginError", null)
    //正在创建用户
    const url = err.request.responseURL
    const queryString = url.substring(url.indexOf('?'))
    const searchParams = new URLSearchParams(queryString)
    const userCreationId = searchParams.get('user_creation_id')
    context.dispatch("checkUserCreation", userCreationId)
    checkCartoUserCreationIntervalId = setInterval(() => context.dispatch("checkUserCreation", userCreationId), 50000);
  }
}

export async function checkUserCreation(context, userCreationId) {
  const checkUserCreationUrl = "/confirmation_state"
  const request = {
    method: 'get',
    baseURL: CARTODB_AUTH_SERVER,
    url: checkUserCreationUrl,
    params: {
        user_creation_id: userCreationId
    },
  }
  try {
    const resp = await axios(request)
    let { data: userCreation } = resp

    if (userCreation.state === 'success') {
      if (checkCartoUserCreationIntervalId) {
        clearInterval(checkCartoUserCreationIntervalId)
        checkCartoUserCreationIntervalId = null
      }
      context.commit("setCartoUserCreateionState", "success")
      context.dispatch("loginBySocial")
    }
    else {
      context.commit("setCartoUserCreateionState", "processing")
    }
  }
  catch (err) {
    context.commit("setLoginError", "cartodb create user error")
  }

}

//获取cartoConfig
export async function getCartdbConfig(context, cartoUser) {
  //获取cartodb user api_key及base_url
  const { username, api_key } = cartoUser
  const baseURL = `${CARTODB_AUTH_SERVER}/user/${username}`
  //通过api_key获取cartoConfig
  try {
    const client = new AuthenticatedClient(baseURL);
    context.commit("setClient", client, { root: true })
    const { data } = await client.getConfigByApiKey(api_key)
    const { user_data: userData } = data
    context.commit("setCartoConfig", data)
    context.commit("setCartoConfigError", null)
    context.commit('user/setUserData', userData, { root: true })
    const key = "CartoConfig"
    // 7天失效
    const ttl = 7 * 24 * 60 * 60 * 1000
    setWithExpiry(key, data, ttl)
  }
  catch (err) {
    context.commit("setCartoConfigError", "get cartodb config error")
  }
}

export async function getCartodbConfig(context) {
  let baseURL = Cookies.get('_cartodb_new_base_url')
  // to deprecate
  const cartoConfig = getWithExpiry("CartoConfig")
  if (cartoConfig && cartoConfig.user_data) {
    baseURL = cartoConfig.user_data.base_url
  }
  try {
    if (baseURL) {
      const client = new AuthenticatedClient(baseURL);
      context.commit("setClient", client, { root: true })
      const { data } = await client.getConfig()
      const { user_data: userData } = data
      context.commit("setCartoConfig", data)
      context.commit("setCartoConfigError", null)
      context.commit('user/setUserData', userData, { root: true })
    }
  } catch (err) {
    context.commit("setCartoConfigError", "can't get cartodb config")
  }
}

// CARTO-native mode authenticates with CARTO's HttpOnly session cookie.
export async function getCartoSessionConfig(context) {
  context.commit("setCartoConfig", null)
  context.commit('user/setUserData', null, { root: true })
  const baseURL = Cookies.get('_cartodb_new_base_url')
  if (!baseURL) {
    context.commit("setCartoConfig", null)
    context.commit("setCartoConfigError", null)
    return
  }
  try {
    const { data } = await axios.get(`${baseURL}/api/v3/me`, { withCredentials: true })
    context.commit("setCartoConfig", data)
    context.commit("setCartoConfigError", null)
    context.commit('user/setUserData', data.user_data, { root: true })
    context.commit("setClient", new AuthenticatedClient(baseURL), { root: true })
  } catch (err) {
    context.commit("setCartoConfig", null)
    context.commit("setCartoConfigError", "can't get cartodb config")
    context.commit('user/setUserData', null, { root: true })
    context.commit("setClient", new AuthenticatedClient(`${CARTODB_SERVER}/user/dev`), { root: true })
  }
}

function removeCookies() {
  const res = document.cookie;
  const multiple = res.split(";");
  for (let i = 0; i < multiple.length; i++) {
    const key = multiple[i].split("=");
    document.cookie = key[0] + ` =; expires = Thu, 01 Jan 1970 00:00:00 UTC; domain=${get_cookie_domain()}`;
  }
}
export function logout(context) {
  context.commit("setCartoConfig", null)
  context.commit("setMapscloudUser", null)
  context.commit('user/setUserData', null, { root: true })
  const key = "CartoConfig"
  localStorage.removeItem(key)
  localStorage.removeItem("accountName")
  localStorage.removeItem("accessToken")
  removeCookies()

  //reset client
  const { username } = getCARTOData().user_data
  const baseURL = `${CARTODB_AUTH_SERVER}/user/${username}`
  const client = new AuthenticatedClient(baseURL);
  context.commit("setClient", client, { root: true })
}
